import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MD - Dermatology, Fellowship in Hair Restoration",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Beard Transplant Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MD - Dermatology, Fellowship in Cosmetic Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Facial Hair Restoration Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Beard Transplant Expert"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Dermatology, Fellowship in Trichology",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Natural Beard Design Specialist"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MD - Dermatology, Fellowship in Hair Restoration",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "FUE Beard Transplant Expert"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, DNB - Dermatology",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Beard & Mustache Transplant Specialist"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Beard Transplant Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for natural-looking beard restoration with permanent results and customized hairline design.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const BeardTransplant = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Beard Transplant Surgery
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Permanent Beard Restoration with 95% Graft Survival Rate. Natural-looking Results with Custom Beard Design.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Custom Beard Design Consultation
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>95%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Graft Survival Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>4-8</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Hours Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>6-12</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Months Full Results</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>{`98%`}</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Patient Satisfaction</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "candidates", label: "Candidates", icon: "🔍" },
              { id: "techniques", label: "Techniques", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "results", label: "Results", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Beard Transplant Surgery</span>
            </h2>
          </div>

          {/* What is Beard Transplant */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Beard Transplantation
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Beard transplant is a sophisticated cosmetic surgical procedure that involves harvesting hair follicles 
                from the donor area (typically the back of the scalp) and meticulously implanting them into the beard area. 
                This permanent solution addresses patchy beard growth, complete beard absence, mustache gaps, 
                and helps create a well-defined, masculine facial hair pattern that enhances facial features and boosts confidence.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Natural Results</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Custom-designed beard patterns that complement facial structure, natural hair growth direction, 
                      and appropriate density for authentic, masculine appearance.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Permanent Solution</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Transplanted hair follicles maintain their genetic resistance to balding, 
                      providing lifelong beard growth that can be trimmed, shaved, and styled naturally.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Common Beard Issues */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Common Beard Problems & Conditions
            </h3>

            <div className="row">
              {[
                {
                  title: "Patchy Beard", 
                  description: "Uneven beard growth with bald spots or thin areas throughout the beard region",
                  details: "Most common reason for beard transplant"
                },
                {
                  title: "Complete Beard Absence", 
                  description: "Little to no facial hair growth due to genetics, hormones, or medical conditions",
                  details: "Creates full beard from scratch"
                },
                {
                  title: "Scar Coverage", 
                  description: "Transplanting hair into facial scars from acne, injury, or previous surgeries",
                  details: "Camouflages visible scars effectively"
                },
                {
                  title: "Mustache Gaps", 
                  description: "Incomplete mustache growth or gaps in the philtrum area above lip",
                  details: "Creates continuous mustache line"
                },
                {
                  title: "Sideburn Restoration", 
                  description: "Thin or absent sideburns that don't connect properly with beard or hairline",
                  details: "Enhances facial frame definition"
                },
                {
                  title: "Beard Design", 
                  description: "Creating specific beard styles like goatee, circle beard, or designer stubble",
                  details: "Customized aesthetic enhancement"
                }
              ].map((problem, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {problem.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {problem.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {problem.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Transplant Techniques */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Beard Transplant Techniques & Methods
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "FUE (Follicular Unit Extraction)",
                    description: "Modern technique extracting individual follicles without linear scar, allowing precise placement",
                    treatment: "No visible scars, quick recovery, natural results"
                  },
                  {
                    type: "DHI (Direct Hair Implantation)",
                    description: "Advanced FUE variation using implanter pens for direct follicle placement without pre-made incisions",
                    treatment: "Higher density, faster procedure, minimal handling"
                  },
                  {
                    type: "Sapphire FUE",
                    description: "Premium technique using sapphire blades for ultra-precise incisions and optimal healing",
                    treatment: "Reduced trauma, faster healing, superior results"
                  },
                  {
                    type: "Robotic FUE",
                    description: "Computer-assisted follicle extraction with robotic precision and consistency",
                    treatment: "Maximum graft survival, perfect angle control"
                  },
                  {
                    type: "Manual FUE",
                    description: "Traditional manual extraction using specialized punches by skilled surgeons",
                    treatment: "Surgeon control, customizable approach"
                  },
                  {
                    type: "Combination Techniques",
                    description: "Tailored approach using multiple methods for optimal results in different beard areas",
                    treatment: "Customized strategy for each patient"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Candidates & Considerations */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Ideal Candidates & Treatment Considerations
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Ideal Candidates</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Men with patchy or incomplete beard growth</li>
                      <li style={{ marginBottom: "10px" }}>Individuals with facial hair loss due to genetics</li>
                      <li style={{ marginBottom: "10px" }}>Those wanting to cover facial scars with hair</li>
                      <li style={{ marginBottom: "10px" }}>Men seeking specific beard styles or patterns</li>
                      <li>Patients with adequate donor hair supply</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Important Considerations</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Age and stability of facial hair pattern</li>
                      <li style={{ marginBottom: "10px" }}>Donor hair quality and availability</li>
                      <li style={{ marginBottom: "10px" }}>Realistic expectations about density and growth timeline</li>
                      <li style={{ marginBottom: "10px" }}>Skin condition and healing capacity</li>
                      <li>Commitment to post-operative care instructions</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Transplant Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    FUE Beard Transplant Procedure
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Follicular Unit Extraction (FUE) is the gold standard for beard transplantation, 
                    offering natural results with minimal scarring and rapid recovery.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Steps:</h6>
                    <div className="row">
                      <div className="col-12">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}><strong>Donor Harvesting:</strong> Precision extraction of follicles from scalp</li>
                          <li style={{ marginBottom: "8px" }}><strong>Graft Preparation:</strong> Sorting and preparing follicles under microscope</li>
                          <li style={{ marginBottom: "8px" }}><strong>Recipient Site Creation:</strong> Making incisions in beard pattern</li>
                          <li style={{ marginBottom: "8px" }}><strong>Graft Implantation:</strong> Placing follicles in predetermined directions</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Key Advantages:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}><strong>No Linear Scar:</strong> Tiny dot scars that are virtually invisible</li>
                      <li style={{ marginBottom: "8px" }}><strong>Natural Direction:</strong> Hair grows in natural beard patterns</li>
                      <li style={{ marginBottom: "8px" }}><strong>Quick Recovery:</strong> Return to normal activities in 3-5 days</li>
                      <li><strong>Permanent Results:</strong> Lifelong beard growth from transplanted follicles</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Custom Beard Design & Planning
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Design Elements:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}><strong>Facial Analysis:</strong> Custom design based on face shape and features</li>
                      <li style={{ marginBottom: "10px" }}><strong>Hair Direction:</strong> Natural growth patterns for authentic appearance</li>
                      <li style={{ marginBottom: "10px" }}><strong>Density Planning:</strong> Strategic graft distribution for optimal coverage</li>
                      <li style={{ marginBottom: "10px" }}><strong>Style Selection:</strong> Full beard, goatee, mustache, or combination</li>
                      <li><strong>Future Planning:</strong> Considering aging and long-term appearance</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Areas Covered:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Cheeks and sideburns for full beard frame</li>
                      <li style={{ marginBottom: "10px" }}>Mustache and soul patch area</li>
                      <li style={{ marginBottom: "10px" }}>Chin and jawline definition</li>
                      <li style={{ marginBottom: "10px" }}>Neckline and under-chin area</li>
                      <li>Scar camouflage and gap filling</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Features:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>3D simulation for preview of final results</li>
                      <li style={{ marginBottom: "10px" }}>Graft count optimization for natural density</li>
                      <li>Customized approach based on ethnic characteristics</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Growth Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Beard Growth & Results Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Initial Healing",
                    activities: ["Scabbing and redness", "Transplanted hair sheds", "Donor area heals", "Normal washing resumes"]
                  },
                  {
                    period: "Month 1-3",
                    title: "Resting Phase",
                    activities: ["No visible growth", "Follicles establish", "Skin returns normal", "Patience required"]
                  },
                  {
                    period: "Month 4-6",
                    title: "Early Growth",
                    activities: ["First new hairs appear", "Gradual thickening", "Initial coverage", "Regular trimming begins"]
                  },
                  {
                    period: "Month 9-12",
                    title: "Final Results",
                    activities: ["Full density achieved", "Natural beard pattern", "Mature texture", "Style as desired"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Post-operative Care & Maintenance
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Immediate Aftercare</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Avoid touching or scratching transplanted area</li>
                      <li style={{ marginBottom: "10px" }}>Sleep on back with elevated head for first few nights</li>
                      <li style={{ marginBottom: "10px" }}>Follow specific washing instructions provided by surgeon</li>
                      <li>Avoid strenuous exercise and sweating for 2 weeks</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Maintenance</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Regular trimming and grooming as beard grows</li>
                      <li style={{ marginBottom: "10px" }}>Use gentle beard care products without harsh chemicals</li>
                      <li style={{ marginBottom: "10px" }}>Protect from sun exposure with beard balm containing SPF</li>
                      <li>Maintain overall health for optimal hair growth</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How painful is beard transplant surgery?",
                  answer: "Beard transplant surgery is generally well-tolerated with minimal discomfort. The procedure is performed under local anesthesia, which completely numbs both the donor area (scalp) and the recipient area (beard region). Patients may feel a slight pinprick during the anesthetic injections, but the actual transplant process is painless. After the procedure, most patients experience mild soreness in both areas that is easily managed with over-the-counter pain relievers. The donor area might feel similar to a mild sunburn for a few days, while the beard area may have some tightness and minor swelling. Most patients return to normal activities within 2-3 days, with any discomfort resolving completely within the first week. The minimal discomfort is considered well worth the permanent, life-changing results."
                },
                {
                  question: "How long do beard transplant results last?",
                  answer: "Beard transplant results are permanent. The transplanted hair follicles are taken from the 'donor dominant' area at the back of the scalp, which is genetically resistant to balding. These follicles maintain their genetic characteristics when moved to the beard area, meaning they will continue to grow beard hair for life. The transplanted hair goes through normal growth cycles just like natural beard hair - growing, resting, and shedding naturally. Once the initial growth phase begins (around 3-4 months post-surgery), the beard will continue to grow and can be trimmed, shaved, and styled just like natural facial hair. While the transplanted hairs are permanent, it's important to note that natural aging may affect hair characteristics over decades, but the follicles themselves remain active and productive throughout your lifetime."
                },
                {
                  question: "When will I see full results after beard transplant?",
                  answer: "Beard transplant results develop gradually over several months following a predictable timeline: Weeks 1-2: Initial healing with scabbing and redness; Month 1-3: 'Ugly duckling' phase where transplanted hairs shed and no growth is visible; Month 4-6: First signs of new growth appear as fine, thin hairs; Month 6-9: Significant growth and thickening with improved coverage; Month 9-12: Full results with mature hair texture and density; Month 12-18: Final maturation with complete natural appearance. Most patients see noticeable improvement by 6 months and full results by 12 months. The gradual timeline is due to the natural hair growth cycle, where follicles enter a resting phase after transplantation before beginning active growth. Patience during the first few months is crucial for optimal results."
                },
                {
                  question: "Can I shave after beard transplant?",
                  answer: "Yes, you can shave after beard transplant, but there are specific timelines to follow: First 10-14 days: No shaving allowed to protect healing grafts; Week 2-4: Electric clippers only, no razor blades; Month 1-3: Gentle shaving with caution, avoiding pressure on transplanted areas; After 3 months: Normal shaving routine can be resumed. The transplanted hairs are permanent and will grow back even after shaving, just like natural beard hair. In fact, many patients find that regular shaving during the growth phase helps train the hairs to grow in the desired direction. Once fully healed, you can shave, trim, and style your transplanted beard exactly as you would with natural facial hair. The ability to maintain and groom your new beard is one of the key benefits of the procedure."
                },
                {
                  question: "How natural will my beard look after transplant?",
                  answer: "A properly performed beard transplant results in an extremely natural appearance when done by an experienced surgeon. Key factors that ensure natural results include: Hair Direction: Follicles are implanted to follow natural beard growth patterns; Gradual Density: Higher density in central areas, lighter at edges for soft transition; Single Follicle Placement: Mimics natural beard growth rather than clumped appearance; Custom Design: Beard pattern tailored to your facial structure and features; Texture Matching: Donor hair selected to match natural beard characteristics. The goal is to create a beard that looks like it grew naturally, with appropriate hair angles, distribution, and characteristics. Most people cannot distinguish a well-transplanted beard from a natural one. The transplanted hair will grow at the same rate as your natural beard hair, can be styled similarly, and will require the same maintenance. The results are designed to be undetectable and completely natural-looking."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready for Your New Beard?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert team provides natural-looking beard transplants with permanent results and custom design.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Hair Restoration: <strong>080-6541-7705</strong> | Dermatology: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default BeardTransplant;